import CONFIG from "../../inc/Config";
import { store } from "../reducers";

// Базовый класс API: fetch, заголовки, разбор ответа, сериализация GET-параметров.
// Прямой fetch из компонентов ЗАПРЕЩЁН — только через цепочку ApiInit → ApiModel → Api<Entity>.
export default class ApiInit {
    // Мост в UI: {messages} — устанавливается один раз в App.js для тостов из моделей.
    static contextApp = null;

    constructor({ baseUrl = '/api', version = '/v0' } = {}) {
        this.baseUrl = baseUrl;
        this.version = version;
    }

    getUrl(path) {
        return `${CONFIG.serverUrl}${this.baseUrl}${this.version}/${path}`;
    }

    getHeaders() {
        return {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        };
    }

    getAccessToken() {
        return store.getState().app.accessToken;
    }

    getRefreshToken() {
        return store.getState().app.refreshToken;
    }

    // Тост из модели: type — 'success' | 'warning' | 'error'.
    addMessages(message, type = 'success') {
        if (ApiInit.contextApp && ApiInit.contextApp.messages) {
            ApiInit.contextApp.messages.addMessage(message, type);
        }
    }

    // Сериализация query-строки: массивы → key[]=, пустые/null отбрасываются.
    pasreParamsForGet(params = {}) {
        const parts = [];
        for (const key in params) {
            const value = params[key];
            if (value === undefined || value === null || value === '') continue;
            if (Array.isArray(value)) {
                for (const item of value) {
                    if (item === undefined || item === null || item === '') continue;
                    parts.push(`${encodeURIComponent(key)}[]=${encodeURIComponent(item)}`);
                }
            } else {
                parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
            }
        }
        return parts.length ? `?${parts.join('&')}` : '';
    }

    // Единая точка запроса. Всегда возвращает {result, response, code};
    // сеть упала / сервер недоступен → {result: false, response: null, code: -1}.
    async __query(path, method = 'GET', data = null, type = null) {
        let url = this.getUrl(path);
        const options = { method, headers: this.getHeaders() };
        if (data !== null && method === 'GET') {
            url += this.pasreParamsForGet(data);
        } else if (data !== null) {
            // FormData (файлы) уходит как есть, остальное — JSON
            options.body = (data instanceof FormData) ? data : JSON.stringify(data);
        }
        try {
            const fetchResponse = await fetch(url, options);
            let response = null;
            try {
                response = await fetchResponse.json();
            } catch (error) {
                response = null; // пустое тело (204) или не-JSON
            }
            return { result: fetchResponse.ok, response, code: fetchResponse.status };
        } catch (error) {
            return { result: false, response: null, code: -1 };
        }
    }
}
